module.exports = __webpack_public_path__ + "img/fish.be5030ca.webp";